import fullScreen from '../../../../../../assets/icons/fullScreen.svg';
import cls from './FullScreenButton.module.scss';
interface FullScreenButtonProps {
    onToggleFullScreen: () => void;
}

const FullScreenButton = ({onToggleFullScreen}: FullScreenButtonProps) => (
    <button
        className={cls.button}
        onClick={onToggleFullScreen}
    >
        {<img src={fullScreen} alt="fullScreen"/>}
    </button>
);
export default FullScreenButton;